import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface AdSenseProps {
  client: string; // e.g., 'ca-pub-XXXXXXXXXXXXXXXX'
  slot: string; // e.g., 'XXXXXXXXXX'
  style?: React.CSSProperties; // CSS styles for the ad container
  format?: string; // e.g., 'auto', 'fluid'
  responsive?: boolean; // Enable responsive ads
  layout?: string; // e.g., 'in-article'
}

const AdSense: React.FC<AdSenseProps> = ({
  client,
  slot,
  style = { display: 'block', textAlign: 'center' },
  format = 'fluid',
  responsive = true,
  layout = 'in-article',
}) => {
  const { pathname } = useLocation(); // Detect route changes

  useEffect(() => {
    if (typeof window !== 'undefined' && Array.isArray((window as any).adsbygoogle)) {
      try {
        ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
        console.log(`AdSense pushed for slot: ${slot}`);
      } catch (err) {
        console.error('AdSense error:', err);
      }
    } else {
      console.warn('AdSense script not loaded or adsbygoogle not available');
    }

    // Cleanup on unmount to prevent duplicate pushes
    return () => {
      if (typeof window !== 'undefined' && Array.isArray((window as any).adsbygoogle)) {
        (window as any).adsbygoogle.length = 0;
      }
    };
  }, [pathname, client, slot]); // Re-run on route or prop changes

  return (
    <ins
      key={`${client}-${slot}-${pathname}`} // Unique key to force remount
      className="adsbygoogle"
      style={style}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? 'true' : 'false'}
      data-ad-layout={layout}
      data-adtest={process.env.NODE_ENV === 'development' ? 'on' : undefined} // Test ads in development
    />
  );
};

export default AdSense;